module.exports = __webpack_public_path__ + "static/media/brand-icons.e8c322de.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/brand-icons.woff2
// module id = 4412
// module chunks = 0